import {PAYMENT_LINK_V2_FEATURES} from '../../../models/constants/constants';

export const CHECKOUT_BUTTON_APPLEPAY_ID = '#applepay-container';
export const CHECKOUT_BUTTON_GOOGLEPAY_ID = '#googlepay-container';

export const REDIRECT_URLS = {
  SUCCESS: (feature?: string) => {
    switch (feature) {
      case PAYMENT_LINK_V2_FEATURES.SPLITS:
        return 'splits/success';
      case PAYMENT_LINK_V2_FEATURES.GROUPS:
        return 'groups/success';
      default:
        return 'payment-link/v2/success';
    }
  },
  FAILURE: (paymentLinkId: string) =>
    `payment-link/v2/${paymentLinkId}?failure=true`,
};

export const DELAY_AUTO_CLICK = 2000;
